export const orderFlow = {
  pending_dispatch: ["claimed", "cancelled"],
  claimed: ["assigned", "cancelled"],
  assigned: ["pending_user_payment", "cancelled"],
  pending_user_payment: ["scheduled", "cancelled"],
  scheduled: ["in_progress", "cancelled"],
  in_progress: ["completed", "failed"],
  completed: ["provider_payment_confirmation_pending"],
  provider_payment_confirmation_pending: ["awaiting_review"],
  awaiting_review: ["closed", "refunded"],
  closed: [],
  cancelled: [],
  failed: [],
  refunded: [],
};
